<template>
     <modal
          class="new-modal-default"
          transition="nice-modal-fade create-configure"
          :name="modal_name" 
          :delay="100" 
          :width="400"
          :height="300"
          :adaptive="true" :clickToClose="false"
     >
          <div class="v-modal-content" style="background-color: #ffffff !important;">
               <div class="v-modal-header-new">
                    <div></div>
                    <div>
                        <span v-if="mode == 'create'" class="v-modal-dialog-title-new v-modal-title fs-20">Add Facility Area & Location Setup</span>
                        <span v-if="mode == 'edit'" class="v-modal-dialog-title-new v-modal-title fs-20">Edit Facility Area & Location Setup</span>
                    </div>
                    <!-- <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideModal"></span>
                    </div> -->
               </div>
               <div class="mb-3">
                    
                    <div>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'create'">Area and Location Info</span>
                        <span class="fs-12 text-secondary ml-5" v-if="mode == 'edit'">Area and Location Info</span>
                    </div>
                </div>
               <div class="v-modal-body" style="height:480px;">
                    <div class="v-modal-layout px-4" style="border: 0.5px solid #0d84f2; border-radius: 6px;">
                         <div  class="d-flex align-items-center py-2 mt-2">
                                <span class=" fw-600 fs-15 mr-2" style="width: max-content;min-width: max-content; color:#130e0e">Facility Area Details</span>
                                <div class="inner-line-hr w-100"></div>
                            </div>
                         <div class="row">
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-500 text-black">Facility Name<span class="text-danger">*</span></label>
                                             <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" name="facility_name" v-model="facility_name" maxlength="30" type="text" autocomplete="off" placeholder="Enter Facility Name" />
                                             <span class="inputBorder"></span>
                                             <div class="d-flex justify-content-between mt-2"></div>
                                                  <div class="invalid-feedback-form text-danger " v-show="errors.has('facility_name')">{{errors.first('facility_name')}}</div>
                                                  <div class="text-right fs-14 w-100">{{30 - facility_name.length}} / 30</div>
                                             </div> 
                                        </div>
                                   <el-checkbox v-model="generate_qr_code" :disabled="is_view_screen" class="mt-2 ml-2">Generate QR Code</el-checkbox>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-500 text-black">Area<span class="text-danger">*</span></label>
                                             <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" name="area" v-model="area" type="text" maxlength="30" autocomplete="off" placeholder="Enter Area" />
                                             <span class="inputBorder"></span>
                                             <div class="text-right fs-14">{{30 - area.length}} / 30</div>
                                        </div> 
                                        <span class="invalid-feedback-form text-danger mt-0" v-show="errors.has('area')">{{errors.first('area')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-500 text-black">Description</label>
                                             <input class="inputFieldNew inputFieldNew-padding" name="description" v-model="description" type="text" maxlength="250" autocomplete="off" placeholder="Enter Description" />
                                             <span class="inputBorder"></span>
                                             <div class="text-right fs-14">{{250 - description.length}} / 250</div>
                                        </div> 
                                   </div>
                              </div>
                         </div>
                         </div>
                         <div class="mt-2 px-4" style="border: 0.5px solid #0d84f2; border-radius: 6px;">
                              <div  class="d-flex align-items-center py-2 mt-2">
                                <span class=" fw-500 mr-2 fs-15" style="width: max-content;min-width: max-content; color:#130e0e">Location Introduced</span>
                                <div class="inner-line-hr w-100"></div>
                            </div>
                         <div class="row"> 
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <span class="whiteSpace fs-14 fw-500 text-blackpx-2">Location<span class="text-danger">*</span></span>
                                        <div class="d-flex align-items-center mt-2">
                                             <div class="form-group w-100 gMap" style="position:relative;">
                                                  <gmap-autocomplete class="" id="autocompleteInput"  name="location"  placeholder="Search Location"
                                                       @place_changed="setPlace($event)"
                                                       :value="facility_address.location_vmodel"
                                                       style="padding: 8px 88px 8px 18px !important; height: 40px;background: #f1f1f1; width:100%; border:none !important;"></gmap-autocomplete>
                                                  <div class="d-flex">
                                                       <i class="icon icon-map-marker color-blue" style="position: absolute;right: 5px;bottom: 9px;"></i>
                                                  </div>
                                             </div>
                                             <div class="gps-logo pointer" @click="getLocation()">
                                                  <i class="icon-crosshairs-gps color-blue" ></i>
                                             </div>
                                        </div>
                                        <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('location')">{{errors.first('location')}}</span> -->
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <span class="whiteSpace fs-14 fw-500 text-black pl-2">Country<span class="text-danger">*</span></span>
                                        <div class="">
                                             <multiselect
                                                  v-model="facility_address.country"
                                                  class="diginew-multiselect diginew-multiselect-dropdown mt-3"
                                                  :options="country_options"
                                                  :searchable="true"
                                                  :close-on-select="true"
                                                  v-validate="'required'"
                                                  :show-labels="false"
                                                  :allow-empty="false"
                                                  :multiple="false"
                                                  name="country"
                                                  :options-limit="3000"
                                                  @select="countryClosed"
                                                  :max-height="200"
                                                  :clear-on-select="false"
                                                  placeholder="Select Country"
                                                  :internal-search="true"
                                                  :show-no-results="true"
                                                  :hide-selected="false"
                                             >   
                                             <template slot="tag">
                                                  <span class="custom__tag">
                                                  </span>
                                             </template>
                                             <template slot="noResult">
                                                  <div class="text-secondary text-center fw-500">No Results Found</div>
                                             </template>
                                             </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('country')">{{errors.first('country')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <span class="whiteSpace fs-14 fw-500 text-black pl-2">State<span class="text-danger">*</span></span>
                                        <div class="">
                                             <multiselect
                                             v-model="facility_address.state"
                                             class="diginew-multiselect diginew-multiselect-dropdown mt-3"
                                             id="ajaxpr"
                                             :loading="state_loading"
                                             :options="state_options"
                                             :searchable="true"
                                             :close-on-select="true"
                                             v-validate="'required'"
                                             name="state"
                                             :disabled="facility_address.country == ''"
                                             :show-labels="false"
                                             @open="updateState"
                                             :allow-empty="false"
                                             :multiple="false"
                                             :options-limit="3000"
                                             :max-height="200"
                                             :clear-on-select="false"
                                             placeholder="Select State"
                                             :internal-search="true"
                                             :show-no-results="true"
                                             :hide-selected="false"
                                             >   
                                             <template slot="tag">
                                                  <span class="custom__tag">
                                                  </span>
                                             </template>
                                             <template slot="noResult">
                                                  <div class="text-secondary text-center fw-500">No Results Found</div>
                                             </template>
                                             </multiselect>
                                        </div>
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('state')">{{errors.first('state')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-6 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-500 text-black">City<span class="text-danger">*</span></label>
                                             <input class="inputFieldNew inputFieldNew-padding" maxlength="30" name="city" v-validate="'required'" v-model="facility_address.city" type="text" autocomplete="off" placeholder="Enter City" />
                                             <span class="inputBorder"></span>
                                             <div class="text-right fs-14">{{30 - facility_address.city.length}} / 30</div>
                                        </div> 
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('city')">{{errors.first('city')}}</span>
                                   </div>
                              </div>
                              <div class="col-lg-12 col-md-12 col-sm-12">
                                   <div class="form-group contactGroup mb-2 pt-0">
                                        <div class="w-100" style="position: relative;">
                                             <label class="inputLabel fs-14 fw-500 text-black">Address<span class="text-danger">*</span></label>
                                             <input class="inputFieldNew inputFieldNew-padding" maxlength="100" name="address" v-validate="'required'" v-model="facility_address.full_address" type="text" autocomplete="off" placeholder="Enter Address" />
                                             <span class="inputBorder"></span>
                                             <div class="text-right fs-14">{{200 - facility_address.full_address.length}} / 200</div>
                                        </div> 
                                        <span class="invalid-feedback-form text-danger" v-show="errors.has('address')">{{errors.first('address')}}</span>
                                   </div>
                              </div>
                         </div>
                    </div>
                    <div class="v-modal-dialog-actions-new">

                         <div class="d-flex justify-content-center align-items-center mt-5">
                              <button class="btn btn-danger-new   mr-3" @click="hideModal">Cancel</button>
                              <button class="btn btn-green  ml-3" :disabled="is_api_calling" @click="saveCreateData" :class="{'text-align-left': is_api_calling}">
                                   {{ is_api_calling ? 'Saving' : 'Save' }}
                                   <half-circle-spinner v-if='is_api_calling' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                              </button>
                         </div>
                    </div>
               </div>
          </div>
          <Locator product_name="DigiHelp" :facility_address="facility_address" />
          <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
          <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
     </modal>
</template>

<script>
import axios from "axios";
import {Locator} from '@digicollect_front_end/digi-fe-library'
import global from "../../global";
import countries from '../../JSONS/country.json';
import { SweetModal } from 'sweet-modal-vue';
import { HalfCircleSpinner } from "epic-spinners";
import facility_mgmt from '../../mixins/facility_mgmt';
import VueBus from 'vue-bus';
import {EventBus} from "../../eventBus/nav-bar-event.js";
export default {
     mixins: [facility_mgmt],
     props: ['modal_name', 'facility_id', 'mode'],
     components: {
          SweetModal,
          HalfCircleSpinner,
          VueBus,
          Locator
          // 'digi-locator': DigiCollectLibrary.Locator
     },
     data(){
          return{
               success_msg: '',
               warning_msg: '',
               facility_name: '',
               area: '',
               description: '',
               Address: '',
               country: '',
               country_options: countries,
               state: '',
               generate_qr_code: false,
               state_options:[],
               city: '',
               city_options: [],
               location:{
                    full_address:''
               },
               facility_address: {
                    country: '',
                    state: '',
                    city: '',
                    address: '',
                    street1: '',
                    township: '',
                    zip_code: '',
                    location_vmodel: '',
                    full_address: ''
               },
               state_loading: false,
               is_api_calling: false,
               attachments: ""
          }
     },
     methods: {
          hideModal(){
               this.$emit('hide-facility-area-modal')
          },
          setPlace(place) {
               let address = place.formatted_address.split(", ");
               this.facility_address.street1 =
                    address[address.length - 6] || "";
               this.facility_address.township =
                    address[address.length - 4] || "";
               this.facility_address.city = address[address.length - 3] || "";
               let statezip = address[address.length - 2]
                    ? address[address.length - 2].split(" ")
                    : ["", ""];
               if (statezip.length == 1) {
                    if (statezip[0].match(/^[0-9]+$/)) {
                    this.facility_address.zip_code = statezip[0];
                    } else {
                    this.facility_address.state = statezip[0];
                    }
               } else {
                    this.facility_address.zip_code = statezip[0].match(/^[0-9]+$/)
                    ? statezip[0]
                    : statezip[1].match(/^[0-9]+$/)
                    ? statezip[1]
                    : "";
                    this.facility_address.state = statezip[0].match(/^[a-zA-Z]+$/)
                    ? statezip[0]
                    : statezip[1].match(/^[a-zA-Z]+$/)
                    ? statezip[1]
                    : "";
               }
               if (address[address.length - 1].includes("-")) {
                    let countrySelected = address[address.length - 1].split(" - ");
                    countrySelected.forEach(x => {
                    if (this.countries.includes(x)) {
                         this.facility_address.country = x;
                    } else {
                         this.facility_address.country = "";
                    }
                    });
               } else {
                    this.facility_address.country = address[address.length - 1];
               }
               // this.facility_address.address.latitude = currentPlace.geometry.location.lat() || "";
               // this.facility_address.address.longitude = currentPlace.geometry.location.lng() || "";
               this.facility_address.location_vmodel = place.formatted_address;
               this.facility_address.full_address = place.formatted_address;
               this.$forceUpdate();
          },
          getLocation() {
               this.$bus.emit('googleLocator')
               EventBus.$emit('googleLocator')
               // // this.addressIndex = index;
               // if (navigator.geolocation) {
               //      console.log("Geolocation is supported!");
               //      // timeout at 60000 milliseconds (60 seconds)
               //      var options = {
               //           enableHighAccuracy: false,
               //           timeout: 300000, // milliseconds (30 seconds)
               //           maximumAge: 600000
               //      }; // milliseconds (10 minutes)
               //      navigator.geolocation.getCurrentPosition(
               //           this.showLocation,
               //           this.errorHandler,
               //           options
               //      );
               // } else {
               //      alert("Sorry, browser does not support geolocation!");
               // }
          },
          // showLocation(position) {
          //      this.latitude = position.coords.latitude;
          //      this.longitude = position.coords.longitude;
          //      let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
          //      let calllatlong = axios.create();
          //      delete calllatlong.defaults.headers.common['Authorization'];
          //      calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue + "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
          //      .then(response => {
          //           let address = response.data.results[0].formatted_address.split(", ");
          //           this.facility_address.street1 =
          //           address[address.length - 6] || "";
          //           this.facility_address.township =
          //           address[address.length - 4] || "";
          //           this.facility_address.city = address[address.length - 3] || "";
          //           let statezip = address[address.length - 2]
          //           ? address[address.length - 2].split(" ")
          //           : ["", ""];
          //           this.facility_address.zip_code = statezip[0].match(/^[0-9]+$/)
          //           ? statezip[0]
          //           : statezip[1].match(/^[0-9]+$/)
          //           ? statezip[1]
          //           : "";
          //           this.facility_address.state = statezip[0].match(/^[a-zA-Z]+$/)
          //           ? statezip[0]
          //           : statezip[1].match(/^[a-zA-Z]+$/)
          //           ? statezip[1]
          //           : "";
          //           if (address[address.length - 1].includes("-")) {
          //           let countrySelected = address[address.length - 1].split(" - ");
          //           countrySelected.forEach(x => {
          //                if (this.countries.includes(x)) {
          //                this.facility_address.country = x;
          //                } else {
          //                this.facility_address.country = "";
          //                }
          //           });
          //           } else {
          //           this.facility_address.country = address[address.length - 1];
          //           }
          //           this.facility_address.location_vmodel = response.data.results[0].formatted_address;
          //           this.facility_address.full_address = response.data.results[0].formatted_address;
          //           this.$forceUpdate();
          //      })
          //      .catch(e => {
          //           // this.errors.push(e)
          //      });
          // },

          locationData(address, location_vmodel, full_address){
               this.facility_address.street1 =
               address[address.length - 6] || "";
               this.facility_address.township =
               address[address.length - 4] || "";
               this.facility_address.city = address[address.length - 3] || "";
               let statezip = address[address.length - 2]
               ? address[address.length - 2].split(" ")
               : ["", ""];
               this.facility_address.zip_code = statezip[0].match(/^[0-9]+$/)
               ? statezip[0]
               : statezip[1].match(/^[0-9]+$/)
               ? statezip[1]
               : "";
               this.facility_address.state = statezip[0].match(/^[a-zA-Z]+$/)
               ? statezip[0]
               : statezip[1].match(/^[a-zA-Z]+$/)
               ? statezip[1]
               : "";
               if (address[address.length - 1].includes("-")) {
               let countrySelected = address[address.length - 1].split(" - ");
               countrySelected.forEach(x => {
                    if (this.countries.includes(x)) {
                    this.facility_address.country = x;
                    } else {
                    this.facility_address.country = "";
                    }
               });
               } else {
               this.facility_address.country = address[address.length - 1];
               }
               this.facility_address.location_vmodel = location_vmodel;
               this.facility_address.full_address = full_address;
               this.$forceUpdate();
          },
          errorHandler(err) {
               if (err.code == 1) {
                    alert("Please Allow Location Access");
               } else if (err.code == 2) {
                    alert("Error: Position is unavailable!");
               }
          },

          countryClosed(value) {
               if(value != this.facility_address.country) {
                    this.facility_address.city = "";
                    this.facility_address.state = "";
                    this.facility_address.full_address = "";
                    this.facility_address.location_vmodel = "";
               }
          },
          updateState() {
               this.state_loading = true;
               if (this.facility_address.country) {
                    let params = {
                         country_required: false,
                         state_required: true,
                         country_name: this.facility_address.country,
                    };
                    this.$http.post(global.CRM_API + "/location/get_location", params).then(res => {
                         if (res.data.status_id == 1 && "all_states" in res.data.response) {
                              res.data.response.all_states.forEach(x => {
                                   this.state_options.push(x);
                              });
                              this.state_loading = false;
                         }
                    });
               }
          },
          async fetchDataById(id) {
               try {
                    let params = {
                         facility_id: id
                    };
                    let response = await this.getFacilityLocationById(params);
                    this.facility_name = response.response.facility_details.facility_name
                    this.description = response.response.facility_details.description
                    this.facility_address.country = response.response.facility_details.country
                    this.facility_address.state = response.response.facility_details.state
                    this.facility_address.city = response.response.facility_details.city
                    this.facility_address.full_address = response.response.facility_details.address
                    this.facility_address.location_vmodel = response.response.facility_details.address
                    this.area = response.response.facility_details.area
               }
               catch (e) {
                    this.warning_msg = e;
                    this.$refs.warning_modal.open();
               }
               
          },
          saveCreateData() {
               if(this.facility_address.location_vmodel == ''){
                    this.facility_address.location_vmodel = this.facility_address.full_address
               }
               this.$validator.validateAll().then(async result => {
                    if (result && this.facility_address.location_vmodel) {
                         this.saveSuccess();
                    } else {
                         this.warning_msg = "Please fill all the required fields";
                              this.$refs.warning_modal.open();
                         setTimeout(() => {
                              this.$refs.warning_modal.close();
                         }, 3000);
                    }
               });
          },
          async saveSuccess() {
               this.is_api_calling = true;
               try {
                    let response;
                    if(this.mode == 'create') {
                         response = await this.createFacilityLocation(this.create_data);
                    } else {
                         this.create_data.facility_id = this.facility_id;
                         response = await this.updateFacilityLocation(this.create_data);
                    }
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                         this.$refs.success_modal.close();
                         this.hideModal();
                         this.$emit('saveSuccess')
                    }, 3000);
               }
               catch (error) {
                    this.is_api_calling = false;
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
               }
          }
     },
     mounted() {
        this.$bus.on('locationData', (address, location_vmodel, full_address) => {
            this.locationData(address, location_vmodel, full_address)
        });
          if(this.mode == 'edit') {
               this.fetchDataById(this.facility_id);
          }
     },
     computed: {
          create_data() {
               return {
                    address: this.facility_address.full_address,
                    area: this.area,
                    city: this.facility_address.city,
                    country: this.facility_address.country,
                    description: this.description,
                    facility_name: this.facility_name,
                    location: this.facility_address.location_vmodel,
                    state: this.facility_address.state,
                    generate_qr_code: this.generate_qr_code
               }
          }
     },
     created() {
          const dict = {
               custom: {


                    facility_name:{
                         required:() => "Facility Name is required"
                    },
                    area:{
                         required:() => "Area is required"
                    },
                    // location:{
                    //      required:() => "Location is required"
                    // },
                    country:{
                         required:() => "Country is required"
                    },
                    state:{
                         required:() => "State is required"
                    },
                    city:{
                         required:() => "City is required"
                    },
                    address:{
                         required:() => "Address is required"
                    },
               }
          }
          this.$validator.localize('en', dict)
     }
}

</script>

<style scoped>
.inner-line-hr{
    border: 0;
    width: 100%;
    border-top: 2px solid #a5a5a5;
}
.border{
    border:0.5px solid #0d84f2 !important;
}
.v-modal-dialog-actions-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 0px solid transparent;
}

.v-modal-header-new {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: flex-start;
    padding-left: 15px;
    padding-top: 15px;
    border-bottom: 0px solid #E9ECEF;
    -webkit-border-top-left-radius: 15px;
    border-top-left-radius: 15px;
    -webkit-border-top-right-radius: 15px;
    border-top-right-radius: 15px;
    background-color: white !important;
}
.v-modal-dialog-title-new{
    margin-bottom: 0px !important;
    font-size: 20px !important;
    font-weight: 600 !important;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    color: #00448b !important;
    padding: 4px !important;
}
     .sub-head{
          font-weight: 500;
          text-align:left;
          color: #005dae; 
     }
     .color-blue{
          color: #005dae;
     }
     .bord-rad-18px{
          border-radius: 18px !important;
     }
     .gps-logo{
          border-radius: 5px;
          padding: 3px;
          border: 1px solid rgb(0, 0, 0);
          position: relative;
          top: -4px;
          margin-left: 5px;
     }
     .form-group, .form-check {
          will-change: unset !important;
     }
     .form-group {
          padding-top: 0.6rem;
          margin-bottom: 1.2rem;
     }


</style>
